import { oc } from '@orpc/contract';
import * as z from 'zod';
import { instantSchema } from '../primitives/time.js';
import { API_VERSION } from './version.js';
export const healthContract = {
    check: oc.route({ method: 'GET', path: `/${API_VERSION}/health` }).output(z.object({
        status: z.literal('ok'),
        version: z.string(),
        /** Server time, so a client can detect its own clock drifting. */
        time: instantSchema,
    })),
};
//# sourceMappingURL=health.js.map